export default __webpack_public_path__ + "static/media/bus.ff70d462.png";